// ATB Constants
// It should be part of ATB repo, but for some reason it doesn't work properly.
// Viddhiyartha Panjarethinam said we have to store it on our side until cli team resolves it.
// TODO Wipe out
export const CS_PHONE_NUMERIC = '1-800-777-0000';
export const YOU_SAVED = 'Estimated savings';
export const REGISTRY_FOR = 'For';
export const ATB_PROS_ZONES = ['ATBPage_Overlay'];
export const MERCHANT_NAME = 'bloomingdales';
